/** Points-to-pixels conversion constant. 1 pt = 4/3 px (at 96 dpi screen resolution). */
export const PX_PER_PT = 4 / 3;

/** Convert typographic points to CSS pixels. */
export function ptsToPxls(pts) {
	return pts * PX_PER_PT;
}

/** Convert CSS pixels to typographic points. */
export function pxlsToPts(px) {
	return px / PX_PER_PT;
}

/**
 * Return the usable page height (top-to-bottom content area) in pixels.
 * @param {{ top: number, bottom: number }} margins - margin values in points
 * @param {{ height: number }} size - page size in points
 */
export function getBaseHeightInPixels(margins, size) {
	const baseHeightInPts = size.height - margins.top - margins.bottom;
	return baseHeightInPts * PX_PER_PT;
}

/**
 * Return the usable page height (top-to-bottom content area) in points.
 * @param {{ top: number, bottom: number }} margins - margin values in points
 * @param {{ height: number }} size - page size in points
 */
export function getBaseHeightInPts(margins, size) {
	return size.height - margins.top - margins.bottom;
}
